import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography } from '@mui/material';
import GlassModal from '../../../../v2/MUI_custom_component/Modal/GlassModal';
import { CustomButton } from '../../../../v2/MUI_custom_component';
import BeneficiarySelectCard from './BeneficiarySelectCard';
import { setGapExistingBeneficiary } from '../reducer/gapBeneficiaryReducer';
import { useNavigate } from 'react-router-dom';
import { submitBeneficiaryNominee } from '../APIs/action';
import { toast } from 'react-toastify';

const ExistingBeneficiaryModal = ({
  onClose,
  open,
  data = [],
  insuranceData,
  returnTransactionId,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedId, setSelectedId] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const { selectedEntity: company_esi_id } = useSelector(
    (state) => state.entityReducer,
  );
  const gapBeneficiaryState = useSelector(
    (state) => state?.gapBeneficiaryReducer || {},
  );

  const selectedBeneficiary = data?.find(
    (b) => b?.beneficiary_details?.id === selectedId,
  );

  const handleSaveWithNominee = () => {
    dispatch(
      setGapExistingBeneficiary(selectedBeneficiary?.beneficiary_details),
    );
    navigate('/beneficiary/add-gap-nominee', {
      state: { insuranceData, returnTransactionId },
    });
    onClose();
  };

  const handleSaveWithoutNominee = async () => {
    dispatch(
      setGapExistingBeneficiary(selectedBeneficiary?.beneficiary_details),
    );
    setSubmitting(true);
    const payload = {
      version: 'v2',
      id_type: 1,
      company_esi_id,
      insurance_id: insuranceData?.benefit_card?.name,
      session_id: returnTransactionId,
      firm_owner_name: gapBeneficiaryState?.firm_owner_name,
      firm_type: gapBeneficiaryState?.firm_type,
      beneficiary: {
        beneficiary_id: selectedBeneficiary?.beneficiary_details?.id,
        full_name: selectedBeneficiary?.beneficiary_details?.header_title,
      },
    };
    const { message, error } = await submitBeneficiaryNominee(payload);
    setSubmitting(false);
    if (!error) {
      toast.success(message || 'Gap beneficiary added successfully');
      navigate('/beneficiary/detail', {
        state: {
          insurance_type: insuranceData?.benefit_card?.name,
          selectedCompanyEntity: company_esi_id,
        },
      });
      onClose();
    } else {
      toast.error(message);
    }
  };

  return (
    <GlassModal
      open={open}
      onClose={onClose}
      title='Select Existing Beneficiary'
      scrollable={true}
      maxWidth='800px'
      zIndex={2}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {data?.map((beneficiary) => (
          <BeneficiarySelectCard
            key={beneficiary?.beneficiary_details?.id}
            beneficiary={beneficiary?.beneficiary_details}
            nominee={beneficiary?.nominee_details}
            selected={selectedId === beneficiary?.beneficiary_details?.id}
            onSelect={() => setSelectedId(beneficiary?.beneficiary_details?.id)}
          />
        ))}

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {selectedBeneficiary &&
              (selectedBeneficiary?.nominee_exists ? (
                <Typography variant='h2'>
                  Beneficiary & Nominee will be added!
                </Typography>
              ) : (
                <Typography variant='h2'>
                  {selectedBeneficiary?.beneficiary_details?.header_title} will
                  be added as beneficiary!
                </Typography>
              ))}
            {selectedBeneficiary &&
              (selectedBeneficiary?.nominee_exists ? (
                <Typography variant='body1'>
                  Are you sure you want to proceed?
                </Typography>
              ) : (
                <Typography variant='body1'>
                  Are you sure you want to proceed to Nominee addition?
                </Typography>
              ))}
          </Box>

          <Box sx={{ display: 'flex', gap: 1 }}>
            <CustomButton
              variant='outlined'
              color='primary'
              label='Cancel'
              onClick={onClose}
              sx={{ flex: 1 }}
            />
            <CustomButton
              variant='filled'
              color='primary'
              label={submitting ? 'Saving...' : 'Save'}
              disabled={!selectedId || submitting}
              onClick={() =>
                selectedBeneficiary?.nominee_exists
                  ? handleSaveWithoutNominee()
                  : handleSaveWithNominee()
              }
              sx={{ flex: 1 }}
            />
          </Box>
        </Box>
      </Box>
    </GlassModal>
  );
};

export default ExistingBeneficiaryModal;
